import React, { useState } from "react";
import { useTheme } from "@mui/material/styles";
import {
  Grid,
  Dialog,
  Typography,
  IconButton,
  Button,
  useMediaQuery,
  Tooltip,
  Box
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {EntitiesAutoComplete} from "../../../Common/EntitiesAutoComplete"
import { ReactComponent as SkillsEditIcon } from "./icons/skilledit.svg";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

export default function NewSkills({open, closePanel, existingSkills}){
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [newSkillList, setNewSkillList] = useState([]);
  return (
    <Dialog 
      onClose={() => {
        setNewSkillList([])
        closePanel()
      }}
      open={open}
      fullScreen={fullScreen}
    >
      <Grid
        container
        justifyContent="flex-start"
        alignItems="flex-start"
        sx={{ p: 2.5 }}
      >
        <Grid item size={{xs:12}} sx={{ bgcolor: "white", borderBottom: "1px solid #EDEFF2", textAlign: "center" }}>
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{ width:"100%", justifyContent:"space-between" }}
          >
            <Grid item>
              <Typography variant="h6" sx={{ fontSize: 16, fontWeight: "bold", color: "#5A6375", textTransform: "capitalize", alignItems: "center", display: "flex" }}>
                <Box component={SkillsEditIcon} sx={{ mx: 1.25 }} />
                Add new skills
              </Typography>
            </Grid>
            <Grid item>
              <IconButton
                aria-label="close"
                className={`close-button`}
                onClick={() => {
                  closePanel();
                }}
              >
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </Grid>
        <Grid item size={{xs:12}} sx={{ p: 2.5 }}>
          <EntitiesAutoComplete
            size={"large"}
            type={"skills"}
            placeholder="Add new Skills"
            onSelect={async (value)=>{
              if (value){
                setNewSkillList([...new Set([...newSkillList, value])]);
              }
            }}
          />
        </Grid>
        <Grid item size={{xs:12}}>
          {newSkillList.map((skill) => ( 
            <Grid
              container
              direction="row"
              justify="space-between"
              alignItems="center"
              spacing={1}
              sx={{ borderTop: "1px solid #EDEFF2" }}
            >
              <Grid item size={{xs:2}}>
                <Tooltip title={"Remove Skill"} arrow placement="top-start">
                  <IconButton
                      aria-label="delete"
                      className={`skill-delete-${skill.replace(/ /gi,"-")}`}
                      onClick={() => setNewSkillList(newSkillList.filter(item => skill !== item))}
                    >
                    <DeleteForeverIcon />
                  </IconButton>
                </Tooltip>      
              </Grid>
              <Grid item size={{xs:10}}>
                <Typography variant="h6" sx={{ fontSize: 14, color: "#5A6375", textTransform: "capitalize" }}>
                  {existingSkills.includes(skill) ? skill + " (You already have this skill)" : skill}
                </Typography>
              </Grid>
          </Grid>
          ))}
        </Grid>
        <Grid item size={{xs:12}} sx={{ display:"flex", flexDirection: "row-reverse" }}>
          <Button 
            variant="contained" 
            color="primary" 
            size="small" 
            onClick={async () => {
              closePanel(newSkillList.filter(item => !existingSkills.includes(item)))
              setNewSkillList([])
            }}
          >
              Save Skills
          </Button>
        </Grid>
      </Grid>
    </Dialog>
  );
}